module.exports = __webpack_public_path__ + "img/bt5_act.373bf0a3.png";